import { render, staticRenderFns } from "./MagneticBrakingViz.vue?vue&type=template&id=d3328b48&scoped=true"
import script from "./MagneticBrakingViz.vue?vue&type=script&lang=js"
export * from "./MagneticBrakingViz.vue?vue&type=script&lang=js"
import style0 from "./MagneticBrakingViz.vue?vue&type=style&index=0&id=d3328b48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3328b48",
  null
  
)

export default component.exports